var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x33_2_Crane_Hook_2_",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x33_2_Crane_Hook"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x33_2_Crane_Hook_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m345.4 296.9 45-128.4c4.3-12.2 3-25.7-3.6-36.8l-29.3-49.5v-71.8c0-5.7-4.7-10.4-10.5-10.4s-10.4 4.7-10.4 10.4v64.1h-161.2v-64.1c0-5.7-4.7-10.4-10.4-10.4-5.8 0-10.4 4.7-10.4 10.4v71.8l-29.3 49.5c-6.6 11.2-7.9 24.6-3.6 36.8l45 128.4c6.1 17.5 22.7 29.3 41.3 29.3h3.6c4.8 30.1 20.6 58.8 47.9 77.6 8.7 6 17.2 7.6 19.8 19.4 3.3 15.4-7.8 28.9-23 31-17.5 3-35.8-10.4-37.9-31.8-1-10.6-9.5-18.7-20.1-19.4-11.9-.8-22.2 8.2-23 20.1-3.1 47.4 35.7 88.5 83.8 88.8 1 0 1.9.1 2.9.1 49.6 0 91.5-43.1 89.6-95.4-.6-26-12.6-52-32.4-69.5-5.7-5.3-13.4-8.1-16.3-20.8.4-.3 31.7 1.4 42.5-29.4zm-159.1-6.9-45-128.4c-2.2-6.4-1.5-13.4 1.9-19.2l27.8-47h170l27.8 47c3.5 5.8 4.2 12.8 1.9 19.2l-45 128.4c-3.2 9.2-11.9 15.3-21.6 15.3h-96.2c-9.7 0-18.4-6.1-21.6-15.3zm118.8 72.6c15.5 13.8 25 34.1 25.4 54.6 1.5 41.4-32.1 75.3-71.1 73.9-37.2-.2-65.6-31.9-63.4-66.5 0-.3.4-.6.7-.6.4 0 .6.4.7 1 3.2 32.8 32.7 55 61.8 50 26.5-3.6 46.2-28.4 40.3-56.1-4.1-19.3-16.5-24-28.4-32.3-20.9-14.3-33.8-36.1-38.5-60.4h48.9c3 20.8 13 27.5 23.6 36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.6 200.4c0-37.9-30.8-68.7-68.7-68.7-37.8 0-68.6 30.8-68.6 68.7s30.8 68.7 68.6 68.7c37.9-.1 68.7-30.9 68.7-68.7zm-68.6 47.7c-26.3 0-47.7-21.4-47.7-47.8 0-26.3 21.4-47.8 47.7-47.8s47.8 21.4 47.8 47.8c-.1 26.4-21.5 47.8-47.8 47.8z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHook);
export default __webpack_public_path__ + "static/media/hook.44c428f7249f5b1a0f1236846d340d68.svg";
export { ForwardRef as ReactComponent };